export default function Dashboard() {
  return (
    <div>
      <h1 className="text-4xl font-bold mb-8">
        Dashboard
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-3xl p-6 shadow-sm">
          <p className="text-gray-500">Total Campaigns</p>
          <h2 className="text-4xl font-bold mt-2">25</h2>
        </div>

        <div className="bg-white rounded-3xl p-6 shadow-sm">
          <p className="text-gray-500">Messages Sent</p>
          <h2 className="text-4xl font-bold mt-2">15000</h2>
        </div>

        <div className="bg-white rounded-3xl p-6 shadow-sm">
          <p className="text-gray-500">Scheduled</p>
          <h2 className="text-4xl font-bold mt-2">12</h2>
        </div>

        <div className="bg-white rounded-3xl p-6 shadow-sm">
          <p className="text-gray-500">Failed</p>
          <h2 className="text-4xl font-bold mt-2">3</h2>
        </div>
      </div>
    </div>
  );
}